window._ = require('lodash');
import Popper from 'popper.js/dist/umd/popper.js';
import Anime from 'animejs/lib/anime.es';
import 'animate.css/animate.css';

window.anime = Anime;
import {Sortable, MultiDrag} from 'sortablejs';
window.Sortable = Sortable;
window.MultiDrag = MultiDrag;

window.$ = window.jQuery = require('jquery');
window.Tether = require('tether');
window.Popper = Popper;
require('bootstrap');
require('magnific-popup/dist/jquery.magnific-popup');
require('magnific-popup/dist/magnific-popup.css');

window.moment = require('moment');
moment.locale('ko');

import Dropzone from 'dropzone';
window.Dropzone = Dropzone;

require('pc-bootstrap4-datetimepicker'); // bootstrap datetime4
window.nestable = require('nestable2'); // nestable
window.feather = require('feather-icons'); // feathericon.com
window.tinymce = require('tinymce'); // tinymce
window.ClipboardJs = require('clipboard'); // clipboard
window.Plyr = require('plyr'); // html5 player
window.slick = require('slick-carousel');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found.');
}

const apiToken = document.head.querySelector('meta[name="api-token"]');
if (apiToken) {
    window.axios.defaults.headers.common.Authorization = `Bearer ${apiToken.content}`;
}

import WebFont from 'webfontloader';

WebFont.load({
    custom: {
        families: [
            'Lato:300,300i,400,400i,700,700i',
            'Noto Sans KR:300,400,700,300i,400i,700i',
            'Noto Serif KR:300,400,700,300i,400i,700i',
            'S-CoreDream:300,400,700',
            'Iropke Batang'
        ],
        urls: ['/assets/css/fonts.css', '//cdn.jsdelivr.net/font-iropke-batang/1.2/font-iropke-batang.css'],
        timeout: 1000
    }
});

$.extend(true, $.fn.datetimepicker.defaults, {
    dayViewHeaderFormat: 'YYYY년 MM월',
    locale: 'ko',
    timeZone: 'Asia/Seoul',
    icons: {
        time: 'datetime-icon datetime-icon-clock',
        date: 'datetime-icon datetime-icon-calendar',
        up: 'datetime-icon datetime-icon-arrow-up',
        down: 'datetime-icon datetime-icon-arrow-down',
        previous: 'datetime-icon datetime-icon-chevron-left',
        next: 'datetime-icon datetime-icon-chevron-right',
        today: 'datetime-icon datetime-icon-check',
        clear: 'datetime-icon datetime-icon-trash',
        close: 'datetime-icon datetime-icon-circle'
    }
});

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

window.animateCss = (element, animationName, callback) => {
    const node = document.querySelector(element)
    node.classList.add('animated', animationName)

    function handleAnimationEnd() {
        node.classList.remove('animated', animationName);
        node.removeEventListener('animationend', handleAnimationEnd);

        if (typeof callback === 'function') callback();
    }

    node.addEventListener('animationend', handleAnimationEnd);
};
